export enum iconNames {
  COMMUNITY = 'community',
  QUESTION = 'question',
  DOWN = 'down',
  PLUS = 'plus',
  CALENDAR = 'calendar',
  GOTO = 'goto',
  LEFTARROW = 'LeftArow',
  RIGHT = 'Right',
  LEFT = 'Left',
  TOP = 'Top',
  BOT = 'Bot',
  TOPARROW = 'TopArrow',
  BOTARROW = 'BotArrow',
  EDIT = 'Edit',
  QUESTIONGRAY = 'QuestionGray',
  LOGOWHITE = 'LogoWhite',
  EYE = 'Eye',
  EYEHIDE = 'EyeHide',
  USER = 'User',
  SIGNOUT = 'SignOut',
  UP = 'Up',
  CHECK = 'Check',
  INSTAGRAM = 'Instagram',
  TWITTER = 'Twitter',
  LINKEDIN = 'Linkedin',
  LINKOTHERS = 'LinkOthers',
  TIKTOK = 'Tiktok',
  YOUTUBE = 'Youtube',
  NOTE = 'Note',
  EXIT = 'Exit',
  SEARCH = 'Search',
  RESTORE = 'Restore',
  MENUICON = 'MenuIcon',
  INTERNALUSER = 'InternalUser',
  NEWS = 'News',
  RESEARCH = 'Research',
  INFO = 'Info',
  TOOL = 'Tool',
  SUBSCRIPTION = 'Subscription',
  CLIENT = 'Client',
  INSTITUTION = 'Institution',
  ADS = 'Ads',
  NEWSLETTER = 'NewsLetter',
  NAVIGATION = 'Navigation',
  LOADING = 'Loading',
  EXCLUSIVE = 'Exclusive',
  WARNING = 'Warning',
  EXCLUSIVECIRCLE = 'ExclusiveCircle',
  DUPLICATE = 'Duplicate'
}
